import React from 'react';
import { MaterialTable } from '../generic'
import moment from 'moment';
import Numeral from 'numeral'
import { withRouter } from 'react-router-dom'


// switch between locales
Numeral.locale('en-za')

let ClientProducts = ({ clients }) => {

  console.log('ClientProducts', clients)
  const columns = [
    {
      Header: 'Client Name',
      accessor: row => `${row.firstNames} ${row.surname}`,
      filter: 'fuzzyText'
    },
    {
      Header: 'Id Number',
      accessor: row => `${row.idType === 'rsa_id' ? '' : row.idNumber ? row.idType : ''}${row.idNumber ? row.idNumber : ''}`,
      filter: 'fuzzyText'
    },
    {
      Header: 'Cell Number',
      id: 'cellNumbers',
      accessor: row => row.cellNumbers ? row.cellNumbers.join(', ') : '',
    },
    {
      Header: 'Email',
      id: 'email',
    },
    {
      Header: 'Claims',
      id: 'claims',
      accessor: row => (row.claims ? row.claims.length : 0),
      disableFilters: true
    },
    {
      Header: 'Funeral Policies',
      id: 'funeralPolicies',
      accessor: row => (row.funeralPolicies ? row.funeralPolicies.length : 0),
      disableFilters: true
    },
    {
      Header: 'Credit Life',
      id: 'creditLifePoliciesIds',
      accessor: row => (row.creditLifePolicies ? row.creditLifePolicies.length : 0),
      disableFilters: true
    },
    {
      Header: 'Created At',
      id: 'createdAt',
      assessor: 'createdAt',
      Cell: ({ value }) => moment(value).format('DD-MM-YYYY'),
      disableFilters: true
    }
  ]

  return (
    <MaterialTable columns={columns} data={clients} onRowPress={(row) => {
      window.open(`/products/${row.idNumber}`, "_blank");
      // runSearch(row.idNumber)
    }} />
  )
}
ClientProducts = withRouter(ClientProducts)
export default ClientProducts

//history.push(`/products/${row.idNumber}`)}